module.exports = __webpack_public_path__ + "media/short-answer.3afdd089.webm";